import { createQuestionSchemaWithMixins } from '../questionSchemaFields';
import { config } from './MediaFileLink.config';

const linkedQuestionId = {
  type: 'object',
  properties: {
    // 10 - длина id опроса
    linkedQuestionId: { type: 'string' },
  },
  required: ['linkedQuestionId'],
} as const;

export const schema = createQuestionSchemaWithMixins({
  mixins: { linkedQuestionId },
  type: config.name,
});
